const en = {
  // Navbar
  nav_product: "Product",
  nav_pricing: "Pricing",
  nav_integrations: "Integrations",
  nav_dashboard: "Dashboard",

  // Hero
  hero_badge: "AI Platform · Available 24/7/365",
  hero_title_1: "Never miss",
  hero_title_2: "another call",
  hero_subtitle: "Your AI receptionist answers, schedules and captures leads in 31 languages, while you focus on growing your business.",
  hero_subtitle_highlight: "in 31 languages",
  hero_ai_name: "AI Receptionist",
  hero_ai_company: "Advanced Health Clinic",
  hero_status_active: "On call",
  hero_ai_greeting: "\"Good morning, Advanced Health Clinic. How can I help you today?\"",
  hero_user_message: "\"I need an appointment with Dr. Martínez this week...\"",
  hero_checking_calendar: "Checking availability ISO 8601...",
  hero_cta_demo: "See Interactive Demo",
  hero_cta_register: "Start Free",
  hero_disclaimer: "No credit card required · 3-minute setup · Cancel anytime",
  hero_stat_calls: "Calls managed",
  hero_stat_uptime: "Uptime SLA",
  hero_stat_savings: "Savings vs call center",
  hero_stat_languages: "Native languages",
  hero_scroll_hint: "Discover more",

  // How it works
  how_label: "How it works",
  how_title_1: "From call to appointment",
  how_title_2: "in under 60 seconds",
  how_subtitle: "Fully autonomous flow. Your team never intervenes. Every step happens in real time.",
  how_total_time: "Total time for the full flow:",
  how_total_time_value: "under 60 seconds",
  how_live_simulation: "Live simulation",
  how_step_label: "STEP",
  how_appointment_confirmed: "Appointment confirmed!",
  how_email_sent: "Email sent",
  how_sms_sent: "SMS sent",
  how_incoming_call: "Incoming call",
  how_check_availability: "Checking availability...",

  // Pricing
  pricing_label: "Pricing Model",
  pricing_title_1: "Transparent pricing,",
  pricing_title_2: "exponential value",
  pricing_subtitle: "No surprises. No fine print. Cancel at any time.",
  pricing_monthly: "Monthly",
  pricing_annual: "Annual",
  pricing_per_month: "/mo",
  pricing_billed_annual: "Billed",
  pricing_per_year: "€/year",
  pricing_secure: "Secure payment with Stripe · Cancel anytime",
  pricing_redirecting: "Redirecting...",
  pricing_error: "Payment could not be initiated. Please try again.",
  pricing_error_connection: "Connection error. Please try again.",
  pricing_enterprise: "Need a custom Enterprise plan?",
  pricing_enterprise_cta: "Talk to our team",
  pricing_popular_badge: "MOST POPULAR",
  pricing_period: "mo",

  // FAQ
  faq_label: "Frequently Asked Questions",
  faq_title_1: "Straight answers to your",
  faq_title_2: "real buying objections",
  faq_subtitle: "No marketing. No fluff. Real answers to what you actually wonder before signing up.",
  faq_cat_all: "All",
  faq_cat_technology: "Technology",
  faq_cat_privacy: "Privacy",
  faq_cat_config: "Setup",
  faq_cat_business: "Business",
  faq_cat_compatibility: "Compatibility",
  faq_cat_implementation: "Implementation",
  faq_cat_integrations: "Integrations",
  faq_unanswered_title: "Your question isn't here?",
  faq_unanswered_desc: "Our team responds in under 2 hours during business hours. No bots, no endless forms.",
  faq_contact_cta: "Write to our team",

  // Wall of Love
  wol_label: "Wall of Love",
  wol_title_1: "Companies that never",
  wol_title_2: "miss a call again",
  wol_cta_title: "Join over 1,200 companies that trust Auria",
  wol_cta_desc: "Average rating of 4.9/5 on G2 and Capterra · No long-term contracts",
  wol_cta_btn: "See Plans & Pricing",

  // CTA Section
  cta_badge: "Start today · No risk",
  cta_title_1: "Capture every opportunity.",
  cta_title_2: "Start in 3 minutes.",
  cta_subtitle: "Over 1,200 companies have already eliminated missed calls forever. Your competition is probably already evaluating it.",
  cta_btn_register: "Start Free",
  cta_btn_demo: "See Demo",
  cta_disclaimer: "14-day free trial · No credit card · No commitment",
  cta_trust_1: "100% secure & encrypted data",
  cta_trust_2: "Setup in under 3 minutes",
  cta_trust_3: "24/7 support in your language",

  // Footer
  footer_desc: "Auria is the AI receptionist platform that eliminates missed calls forever. Available 24/7/365 in 31 languages.",
  footer_newsletter_title: "Get product updates",
  footer_newsletter_placeholder: "your@email.com",
  footer_subscribe_success: "Subscribed successfully!",
  footer_subscribe_error: "Subscription failed. Please try again.",
  footer_copyright: "© 2026 Auria. All rights reserved.",
  footer_status: "All systems operational · 99.7% uptime",
  footer_col_product: "Product",
  footer_col_company: "Company",
  footer_col_legal: "Legal",

  // Footer links
  footer_features: "Features",
  footer_pricing: "Pricing",
  footer_integrations: "Integrations",
  footer_changelog: "Changelog",
  footer_roadmap: "Roadmap",
  footer_about: "About us",
  footer_blog: "Blog",
  footer_use_cases: "Use cases",
  footer_contact: "Contact",
  footer_manage_sub: "Manage subscription",
  footer_privacy: "Privacy",
  footer_terms: "Terms of use",
  footer_cookies: "Cookies",
  footer_gdpr: "GDPR",
  footer_sla: "SLA",

  // Register modal
  register_title: "Start for free",
  register_subtitle: "Your AI receptionist in under 3 minutes",
  register_name_label: "Full name",
  register_name_placeholder: "Your name",
  register_email_label: "Email",
  register_email_placeholder: "you@company.com",
  register_business_label: "Company",
  register_business_placeholder: "Your company name",
  register_phone_label: "Phone (optional)",
  register_phone_placeholder: "+1 600 000 000",
  register_cta: "Create free account",
  register_sending: "Sending...",
  register_success_title: "Welcome to Auria!",
  register_success_desc: "We've sent a confirmation email. Our team will contact you within 24h to set up your AI receptionist.",
  register_demo_link: "Watch the interactive demo while you wait",
  register_disclaimer: "No credit card · Cancel anytime",
  register_or_see_plans: "Prefer to see plans? Go to pricing",
  register_error: "Error sending. Please try again.",

  // Demo modal
  demo_title: "Interactive Demo",
  demo_close: "Close",

  // Cookie banner
  cookie_title: "We use cookies",
  cookie_desc: "We use first- and third-party cookies to improve your experience and analyze website usage.",
  cookie_accept: "Accept all",
  cookie_reject: "Essential only",
  cookie_policy: "Cookie policy",

  // 404
  not_found_title: "Page not found",
  not_found_desc: "The page you are looking for does not exist or has been moved.",
  not_found_cta: "Back to home",

  // Cuenta page
  cuenta_loading: "Loading...",
  cuenta_not_found: "Subscription not found",

  // Bienvenida page
  welcome_title: "Welcome to Auria!",

  // AI labels in HowItWorks
  ai_detecting: "Detecting language...",
  ai_querying: "Querying RAG...",
  ai_analyzing: "Analyzing intent...",
  ai_generating: "Generating response...",

  // Vision Section
  vision_label: "Strategic Vision",
  vision_title: "The real cost of an unanswered call",
  vision_p1: "In 2026, the modern consumer penalises every second of waiting. Human-staffed solutions face structural bottlenecks that no business can afford to ignore.",
  vision_p2: "Organisations that automate phone reception achieve efficiency gains of up to <strong>80%</strong>, turning processes that once took days into resolutions that take minutes.",
  vision_insight_title: "Market Insight 2026",
  vision_insight_desc: "67% of customers who are not attended to never call the same business again.",

  // Canvas Memory form (bienvenida)
  cm_title_business: "Business Details",
  cm_business_name_label: "Business name *",
  cm_business_name_placeholder: "E.g.: Advanced Dental Clinic",
  cm_business_type_label: "Business type *",
  cm_business_type_placeholder: "E.g.: Dental clinic, Law firm, Hair salon...",
  cm_email_contact_label: "Your contact email *",
  cm_address_label: "Address",
  cm_address_placeholder: "Street, number, city",
  cm_title_schedule: "Business Hours",
  cm_mon_fri_label: "Monday to Friday",
  cm_mon_fri_placeholder: "E.g.: 9:00 – 14:00 / 16:00 – 20:00",
  cm_sat_label: "Saturdays",
  cm_sat_placeholder: "E.g.: 10:00 – 14:00 / Closed",
  cm_sun_label: "Sundays and holidays",
  cm_sun_placeholder: "E.g.: Closed",
  cm_title_services: "Services & Pricing",
  cm_service_label: "Service",
  cm_price_label: "Price",
  cm_service_name_placeholder: "Service name",
  cm_price_placeholder: "E.g.: €60",
  cm_other_services_label: "Other services (if any)",
  cm_other_services_placeholder: "List the rest of your services and their prices here...",
  cm_title_appointments: "Appointment Protocol",
  cm_duration_label: "Average appointment duration",
  cm_duration_placeholder: "E.g.: 45 minutes",
  cm_confirmation_label: "Is 24h confirmation required?",
  cm_select_option: "Select...",
  cm_cancellation_label: "Cancellation policy",
  cm_cancellation_placeholder: "E.g.: Give 24h notice",
  cm_title_faq: "Customer FAQs",
  cm_question_label: "Question",
  cm_question_placeholder: "What do your customers usually ask?",
  cm_answer_placeholder: "Answer the AI should give",
  cm_title_extra: "Additional information",
  cm_extra_placeholder: "Any important detail the AI should know: parking, payment methods, service areas, languages...",
  cm_max_chars: "Max. 500 characters",
  cm_submit_btn: "Send Canvas Memory",
  cm_sending: "Sending...",
  cm_success_title: "Canvas Memory sent!",
  cm_success_desc: "We'll configure your AI with this data within 24h. You can mark the step as complete.",
  cm_hint_title: "What is this for?",
  cm_hint_desc: "The Canvas Memory is your AI's knowledge base. The more detail you fill in, the better your AI will answer customer questions about hours, prices and appointments.",
  // ValueProposition
  vp_label: "Value Proposition",
  vp_title_1: "Why the best companies",
  vp_title_2: "choose AI over humans",
  vp_subtitle: "This is not an IVR. It's an autonomous execution system designed to capture every business opportunity.",
  vp_arch_title: "Autonomous execution architecture",
  vp_arch_desc: "Canvas Memory with real-time RAG: any change in your business knowledge is injected into the agent instantly. No retraining, no waiting.",

  // ComparisonSection
  comp_label: "Comparison",
  comp_title_1: "The difference is",
  comp_title_2: "hard to ignore",
  comp_subtitle: "Compare point by point what your current model costs vs what you gain with VoiceAI.",
  comp_without: "Without VoiceAI",
  comp_with: "With VoiceAI",
  comp_cta: "See pricing",

  // DashboardSection
  dash_label: "Control Panel",
  dash_title_1: "Your business,",
  dash_title_2: "under total control",
  dash_subtitle: "Manage your AI receptionist from a minimalist Stripe-inspired dashboard. Three real-impact metrics, Canvas Memory to edit your AI's knowledge in real time, and full control over human transfers.",
  dash_f1_title: "Canvas Memory (Real-time RAG)",
  dash_f1_desc: "Edit your AI's knowledge live. Changes apply instantly.",
  dash_f2_title: "ISO 8601 calendar scheduling",
  dash_f2_desc: "No timezone conflicts. Availability verified before proposing every slot.",
  dash_f3_title: "Contextual human transfer",
  dash_f3_desc: "Semantic detection of VIP cases and emergencies to escalate to the team at exactly the right moment.",
  dash_tab_demo: "Live demo",
  dash_tab_dashboard: "Dashboard",
  dash_repeat_demo: "Replay demo",
  dash_client_label: "Dashboard · Sample Clinic",
  dash_calls_title: "Calls per month",
  dash_calls_growth: "+96% annual",
  dash_recent_calls: "Recent calls",
  dash_vs_prev: "vs previous month",

  // TechArchitectureSection
  tech_label: "Technical Architecture",
  tech_title_1: "Multi-Agent System",
  tech_title_2: "TB-CSPN Framework",
  tech_subtitle: "Not a simple LLM. It's a multi-agent execution architecture structured in three functional layers that orchestrate every call with surgical precision.",
  tech_memory_label: "Memory Infrastructure",
  tech_mem1_title: "ChromaDB — Semantic Memory",
  tech_mem1_desc: "Business RAG: hours, FAQs, service catalogue injected into context",
  tech_mem2_title: "Episodic Memory",
  tech_mem2_desc: "The AI remembers every returning client and the context of past calls",
  tech_mem3_title: "Accumulative Learning",
  tech_mem3_desc: "Successful calls automatically evolve the knowledge base",
  tech_mcp_title: "MCP — Model Context Protocol",
  tech_mcp_desc: "The \"USB-C of AI\": securely connects to any CRM, external database or enterprise system without rewriting code.",
  tech_stack_label: "Tech Stack",

  // VoicePipelineSection
  voice_label: "Voice Processing",
  voice_title_1: "Sub-second latency.",
  voice_title_2: "Absolute naturalness.",
  voice_subtitle: "A pause of more than one second destroys user trust. Our Audio Speech-to-Speech pipeline processes voice end-to-end in under 1 second.",
  voice_simulating: "Simulating...",
  voice_start_sim: "Start simulation",
  voice_pipeline_title: "Realtime Audio Pipeline",
  voice_ws_title: "WebSocket Bridge",
  voice_ws_desc: "Decoupled architecture: switch voice provider (Kokoro → ElevenLabs) without touching business logic",
  voice_a2a_title: "Native Audio-to-Audio",
  voice_a2a_desc: "No intermediate text conversion. The pipeline processes the voice signal directly for minimal latency",
  voice_agnostic_title: "Provider Agnostic",
  voice_agnostic_desc: "Modular integration: OpenAI Realtime, ElevenLabs, Kokoro TTS. Premium clients choose their voice engine",
  voice_delivery_title: "Deliverability & Answer Rates",
  voice_delivery_desc: "A perfect AI is useless if the call arrives marked as SPAM. We implement the full chain of caller identity verification.",
  voice_answer_rate: "+40% answer rate on outbound calls with Branded Caller ID activated",

  // SecurityEvolutionSection
  sec_label: "Security & Scalability",
  sec_title_1: "Built for the world's",
  sec_title_2: "most sensitive data",
  sec_subtitle: "In voice data handling, regulatory compliance is the cornerstone of enterprise trust. Designed from the ground up for HIPAA and GDPR.",
  sec_privacy_title: "Security & Privacy",
  sec_residency_title: "Data Residency Europe",
  sec_residency_desc: "All data stored in Frankfurt (EU-CENTRAL-1). Never leaves the European Union.",
  sec_learning_title: "Build-Collaborate-Evolve Cycle",
  sec_learning_badge: "Accumulative Learning",
  sec_learning_quote: "\"Every successful call makes the system smarter\"",
  sec_episodic_note: "Positive Episodic Memories (successful calls validated by the operator) are automatically transferred to the main RAG, creating a system that evolves organically with every interaction without manual retraining.",
  sec_episodic_strong: "Positive Episodic Memories",
  sec_blueprint_badge: "Blueprint Conclusion",
  sec_blueprint_title: "High-fidelity commercial MVP",
  sec_blueprint_desc: "This system integrates TB-CSPN multi-agent orchestration, sub-second latency and a marketing strategy based on radical transparency. We deliver not just technology, but time and peace of mind: we guarantee that every call becomes a capitalised opportunity.",
  sec_blueprint_strong: "time and peace of mind",
  sec_bp_arch: "Multi-Agent Architecture",
  sec_bp_latency: "Response latency",
  sec_bp_calendar: "Schedule management",
  sec_bp_pii: "Data in transcripts",

  // IntegrationsSection
  int_label: "Integrations & Security",
  int_title_1: "Integrates with everything",
  int_title_2: "you already use",
  int_subtitle: "Connect your technology stack in minutes. No code, no friction.",
  int_counter: "Over 50 native integrations available · Open REST API",
  int_sec_badge: "Enterprise Security",
  int_sec_title: "Built for the most regulated sectors",
};

export default en;
